/**
 * Submission Data Models
 *
 * Submissions represent user-generated content submitted for challenges.
 * When approved by admins, submissions award points to participants.
 *
 * Architecture:
 * - Submission: Main record with content asset and metadata
 * - SubmissionInstance: Per-user participation tracking (1 per participant)
 */
export const POSTED_PLATFORMS = ['instagram', 'tiktok', 'facebook'];
/**
 * Resolves the assets for a submission, sorted by order.
 */
export function resolveAssets(submission) {
    return [...(submission.submissionAssets || [])].sort((a, b) => a.order - b.order);
}
/**
 * Submission Status Enum
 *
 * Represents the approval state of a submission.
 */
export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["PENDING"] = "pending";
    SubmissionStatus["APPROVED"] = "approved";
    SubmissionStatus["REJECTED"] = "rejected";
})(SubmissionStatus || (SubmissionStatus = {}));
